import { forwardRef } from "react";
import { useId } from "react";
function SvgHandOptimizedRawReadAloudGraphicSmall(
  { title, titleId, ...props },
  ref,
) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={244}
      height={40}
      fill="none"
      aria-hidden="true"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <mask
        id={`HandOptimizedRawReadAloudGraphicSmall_svg__b${toAppend}`}
        width={244}
        height={40}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <rect
          width={4}
          height={4}
          x={240}
          y={18}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={232}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={16}
          x={224}
          y={12}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={20}
          x={216}
          y={10}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={14}
          x={208}
          y={13}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={24}
          x={200}
          y={8}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={30}
          x={192}
          y={5}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={184}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={34}
          x={176}
          y={3}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={30}
          x={168}
          y={5}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={30}
          x={160}
          y={5}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={24}
          x={152}
          y={8}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={18}
          x={144}
          y={11}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={136}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={8}
          x={128}
          y={16}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={120}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={16}
          x={112}
          y={12}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={22}
          x={104}
          y={9}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={96}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={88}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={18}
          x={80}
          y={11}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={72}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={14}
          x={64}
          y={13}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={56}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={8}
          x={48}
          y={16}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={6}
          x={40}
          y={17}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={2}
          x={32}
          y={19}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={1}
        />
        <rect
          width={4}
          height={4}
          x={24}
          y={18}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={4}
          x={16}
          y={18}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={4}
          x={8}
          y={18}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={6}
          y={17}
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend})`}
          rx={2}
        />
      </mask>
      <g mask={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__b${toAppend})`}>
        <path
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__c${toAppend})`}
          d="M0 0h244v40H0z"
        />
        <path
          fill={`url(#HandOptimizedRawReadAloudGraphicSmall_svg__d${toAppend})`}
          d="M0 0h244v40H0V0Z"
        />
      </g>
      <defs>
        <radialGradient
          id={`HandOptimizedRawReadAloudGraphicSmall_svg__c${toAppend}`}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(176.089 120.82 10.597) scale(165.878 98.534)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.141} stopColor="#106FF3" />
          <stop offset={1} stopColor="#106FF3" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id={`HandOptimizedRawReadAloudGraphicSmall_svg__d${toAppend}`}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(217.73759 -13.84006 4.1403 65.13705 13.473 26.77)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.197} stopColor="#643DFF" />
          <stop offset={0.384} stopColor="#7B3DFF" stopOpacity={0.38} />
          <stop offset={0.598} stopColor="#25C09B" stopOpacity={0.32} />
        </radialGradient>
        <linearGradient
          id={`HandOptimizedRawReadAloudGraphicSmall_svg__a${toAppend}`}
          gradientTransform="rotate(90)"
        >
          <stop stopColor="#fff" />
          <stop offset="50%" stopColor="#fff" />
          <stop offset="50%" stopColor="#fff" stopOpacity={0.62} />
          <stop offset="100%" stopColor="#fff" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgHandOptimizedRawReadAloudGraphicSmall);
export default ForwardRef;
